import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m5 8 4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m12 15 4 4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Magnet";
const Magnet = memo(themed(Icon));
export {
  Magnet
};
//# sourceMappingURL=magnet.js.map
